/**
 * Created by yuxin Wei on 2017/11/15.
 * 封装常量constants
 */
export default {
  //登录模式
  teachingTag: { isTeaching: 1, isNotTeaching: 0 },

  //任务类型
  record_origin: {
    KeHouLianXi: 1,
    XiaFa: 2,
    QiangDa: 3,
    SuiTang: 4,
    Stop: 5,
  },

  //授课类型
  teaching_type: {
    BeiKe: 1,
  },

  //任务状态
  inactive_state: {
    errorState: -1,
    init: 0,
    doing: 1,
    done: 2,
  },

  //loading类型
  loading: {
    opaque: 0,
    transparency: 1,
  },

  commondsStr: {
    /**
     * 消息类型
     */
    commondType: {
      message: "MESSAGE",
      commond: "COMMAND",
    },
    /**
     * commond消息，该值不能动
     */
    xiaoxi_commond: {
      start: "start",
      stop: "stop",
    },

    /**
     * message：消息，需要根据业务来改
     */
    xiaoxi_message: {
      xiaFa: "xiafa",
      qiangDa: "qiangda",
      shouKong: "shouKong",
      shouKe: "shouke",
      suoPing: "suoping",
      tongPing: "tongPingKeyStart",
      common: "normal",
      stop: "sendEndClientKey",
      suiTang: "suiTang",
    },
    /**
     *common消息：自定义的通用消息
     */
    common_message: {
      endTask: "endTask",
      qiangDaJieGuo: "qiangDaJieGuo",
      qiangDaChengGong: "qiangDaChengGong",
      stopTongPing: "tongPingKeyStop",
      endSuiTang: "endSuiTang",
      daTiJieShu: "daTiJieShu",
      noAnswerJieShu: "noAnswerJieShu",
    },

    configInfo: {
      roomId: "roomid",
    },
  },

  //登录提示
  login_Info: {
    empty: "请输入账号和密码！",
    userNameEmpty: "请输入账号！",
    passWordEmpty: "请输入密码！",
    error: "账号或密码错误！",
    exceptions: "登录失败，服务端异常！",
    loginErrCode: "2002",
    captchaCodeErr: "2021",
    captchaCodeErrText: "验证码错误！",
  },
  submit_Msg: {
    error: "提交过程中出现异常！",
  },

  //loading默认时间10s
  loading_Msg: {
    time: 10000,
    msg: "拼命加载中...",
  },

  tongPingType: { BanJi: "banJi", geRen: "geRen" },

  usingClient: {
    studentClient: "1",
    teacherClient: "0",
  },

  result: {
    success: 1000,
  },

  taskType: {
    classwork: "classwork",
    interaction: "interaction",
  },

  terminal: "PC",

  qiangDaErrorMsg: "answerFailure",

  interfaceResult: {
    success: 1,
    error: 0,
    qiangDaErrorCode: 209,
  },

  //题型常量
  category: {
    word: "read_word", //朗读单词&&字词朗读
    sentence: "read_sentence", //朗读句子
    chapter: "read_passage", //朗读短文&&段落朗读
    listen_shortpassage_record: "listen_shortpassage_record", //听后回答
    choice: "listen_shortpassage_choice", //听后选择 &&听课文，回答问题
    dialog: "read_dialog", //朗读对话
    situational_reply_picture: "situational_reply_picture", //看图问答
    situational_reply_text: "situational_reply_text", //情景问答
    fillblank: "listen_shortpassage_fillblank", //听后填空
    judge: "listen_shortpassage_judge", //听后判断
    listen_phonetic_choice: "listen_phonetic_choice", //听音频，为划线部分选择正确的拼音
    listen_word_choice: "listen_word_choice", //听词语，选择正确的字
    read_chapter: "read_chapter", //听一听，背一背
    recite_chapter: "recite_chapter", //听一听，读一读
    poetry: "poetry", //古诗
    idiom_story_choice: "idiom_story_choice", //成语
  },

  //登录角色
  loginRole: {
    teacher: "teacher",
    student: "student",
  },

  //模块名称
  moduleName: {
    teacher: {
      prepareLessonName: "我的备课",
      textbooksSynchronization: "教材同步",
      specialTopic: "主题专项",
      specialTest: "考试专项",
      inClassTest: "我的备测",
      testRecord: "测试记录",
      practiceEvaluation: "课后练习讲评",
      personalCenter: "个人中心",
    },
    student: {
      ingClasswork: "进行中",
      endClasswork: "已结束",
      specialBreak: "专项突破",
    },
  },
};



// WEBPACK FOOTER //
// ./src/js/constants.js